module.exports = __webpack_public_path__ + "static/media/react.370c97b6.png";